import { noop } from 'lodash';
import { type RefObject, useEffect } from 'react';

import { useFullscreenContext } from '~/components/AssetModalV2/shared/context/FullscreenContext';

type UseRegisterFullscreenControlsProps = {
  containerRef: RefObject<HTMLElement> | null;
  toggleFullscreen: () => void;
};

export const useRegisterFullscreenControls = ({
  containerRef,
  toggleFullscreen,
}: UseRegisterFullscreenControlsProps) => {
  const { setFullscreenContainerRef, setToggleFullscreen } = useFullscreenContext();

  // Register the container ref and toggle function with the context so other components can use them
  useEffect(() => {
    setFullscreenContainerRef(containerRef);
    setToggleFullscreen(toggleFullscreen);
    return () => {
      setFullscreenContainerRef(null);
      setToggleFullscreen(noop);
    };
  }, [setFullscreenContainerRef, setToggleFullscreen, toggleFullscreen, containerRef]);
};
